let _ = t => t,
  _t,
  _t2;
import styled, { css } from 'styled-components';
import Box from '../Box';
export const StyledButtonGroup = styled(Box)(({
  $direction,
  $fullWidth
}) => css(_t || (_t = _`
        display: flex;
        flex-direction: ${0};
        gap: 16px;
        align-items: center;

        padding: 0;

        ${0}
    `), $direction, $fullWidth && css(_t2 || (_t2 = _`
            width: 100%;

            & > button,
            & > a {
                flex: 1;

                width: 100%;
            }
        `))));